import * as React from "react"
import {Link} from 'gatsby';
import Seo from '../components/seo';
import Layout from "../components/layout"
import Button from "../components/button";

const NotFoundPage = () => (
  <Layout>
    <section className="grid min-h-full place-items-center color-scheme-one bg-[var(--color-scheme-background)] px-6 py-24 sm:py-32 lg:px-8">
      <div className="text-center">
        <p className="text-base font-semibold text-[color:var(--color-scheme-text)]">404</p>
        <h1 className="mt-4 text-3xl font-bold tracking-tight text-[color:var(--color-scheme-text)] sm:text-5xl">Page not found</h1>
        <p className="mt-6 text-base leading-7 text-[color:var(--color-scheme-text)]">Sorry, we couldn’t find the page you’re looking for.</p>
        <div className="mt-10 flex items-center justify-center gap-x-6">
          <Button url='/'
            label="Go back home" />
        </div>
      </div>
    </section>
  </Layout>
)

export const Head = () => <Seo title="404: Not Found" />

export default NotFoundPage